// src/components/InsuranceForm.jsx
import React, { useState } from "react";
import { IMaskInput } from "react-imask";

const InsuranceForm = ({
  ramo = "",             // Ex: "Auto", "Vida", "Residencial"
  pageRamo = true,       // true = detecta pelo nome da página, false = o usuário escolhe no select
  showEmail = false,
  showVeiculo = false,
  formUrl,               // URL do Google Forms específico
}) => {
  const [nome, setNome] = useState("");
  const [telefone, setTelefone] = useState("");
  const [email, setEmail] = useState("");
  const [veiculo, setVeiculo] = useState("");
  const [ramoFinal, setRamoFinal] = useState(ramo);
  const [statusMsg, setStatusMsg] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const nomeRegex = /^[A-Za-zÀ-ÿ\s]+$/;
    if (!nomeRegex.test(nome.trim())) {
      setStatusMsg("❌ Nome inválido.");
      return;
    }

    const telefoneLimpo = telefone.replace(/\D/g, "");
    if (telefoneLimpo.length < 10 || telefoneLimpo.length > 11) {
      setStatusMsg("❌ Telefone inválido.");
      return;
    }

    const telefoneIntl = `55${telefoneLimpo}`;
    setStatusMsg("Enviando...");

    const data = new URLSearchParams();
    data.append("entry.426038373", pageRamo ? ramo : ramoFinal); // Substituir pelos seus IDs reais
    data.append("entry.371468472", nome);
    data.append("entry.684960318", telefoneIntl);
    if (showEmail) data.append("entry.848774462", email);
    if (showVeiculo) data.append("entry.697841322", veiculo);

    try {
      await fetch(formUrl, {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });
      setStatusMsg("✅ Enviado com sucesso!");
      setNome("");
      setTelefone("");
      setEmail("");
      setVeiculo("");
    } catch (err) {
      console.error(err);
      setStatusMsg("❌ Erro ao enviar.");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {/* Nome */}
      <div>
        <label className="block text-sm">Nome</label>
        <input
          type="text"
          value={nome}
          onChange={(e) => setNome(e.target.value)}
          required
          pattern="[A-Za-zÀ-ÿ\s]+"
          className="w-full border rounded px-4 py-2"
        />
      </div>

      {/* Telefone */}
      <div>
        <label className="block text-sm">Telefone</label>
        <IMaskInput
          mask={["(00) 00000-0000", "(00) 0000-0000"]}
          value={telefone}
          onAccept={setTelefone}
          required
          className="w-full border rounded px-4 py-2"
        />
      </div>

      {/* Email */}
      {showEmail && (
        <div>
          <label className="block text-sm">E-mail</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full border rounded px-4 py-2"
          />
        </div>
      )}

      {/* Veículo */}
      {showVeiculo && (
        <div>
          <label className="block text-sm">Veículo</label>
          <input
            type="text"
            value={veiculo}
            onChange={(e) => setVeiculo(e.target.value)}
            required
            className="w-full border rounded px-4 py-2"
          />
        </div>
      )}

      {/* Ramo (se não for fixo) */}
      {!pageRamo && (
        <div>
          <label className="block text-sm">Produto</label>
          <select
            value={ramoFinal}
            onChange={(e) => setRamoFinal(e.target.value)}
            className="w-full border rounded px-4 py-2"
            required
          >
            <option value="">Selecione</option>
            <option value="Auto">Auto</option>
            <option value="Vida">Vida</option>
            <option value="Residencial">Residencial</option>
            {/* Adicione outros ramos aqui */}
          </select>
        </div>
      )}

      <button
        type="submit"
        className="w-full bg-orange-500 text-white py-3 rounded hover:bg-orange-600"
        disabled={statusMsg === "Enviando..."}
      >
        {statusMsg === "Enviando..." ? "Enviando..." : "Solicitar Cotação"}
      </button>

      {statusMsg && (
        <p className="mt-2 text-center text-sm text-gray-800">{statusMsg}</p>
      )}
    </form>
  );
};

export default InsuranceForm;